import Avatar from '@material-ui/core/Avatar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import Axios from 'axios';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { AppConfig } from '../../../config/app';
import { DataApi } from '../../../providers/api-provider';
import GlobalStore from '../../../providers/global-store-provider';
import { consumePreferredRoute, getAdminRoles, inIframe, Loader, postMessageToParent, setCookie, showError, showSuccess } from '../libs/helpers';
import styles from './styles/login';

/* Social Login Component */
class SocialLogin extends React.Component {
  state = {
    errors: {
      email: false,
      password: false,
      enabled: false,
    },
    email: '',
    password: '',
    loading: false,
  }
  /*
  -----------------------------------------------------------------------
  API Functions
  -----------------------------------------------------------------------
  */
  componentDidMount() {
    this.performLogin();
  }
  /* API Call */
  performLogin = () => {
    this.setState({ loading: true });
    const token = this.props.match.params.token;
    Axios.defaults.headers.common['Authorization'] = "Bearer " + token;
    DataApi.getOne('auth/user')
      .then((res) => {
        //Set cookie for wordpress website
        setCookie('x_t', token);
        //Show SnackBar
        showSuccess('Welcome Back!');
        res.data.token = token;
        res.data.token_type = 'Bearer';
        GlobalStore.auth.login(res.data);
        const role = GlobalStore.state.auth.user.role;
        this.setState({ loading: false });
        //If it was called from edseed.me send a message
        if(inIframe() && role!=='guest'){
          postMessageToParent('login',{
            loggedIn:true,
            userInfo:res.data
          });
          return;
        }
        //If there is preferred route go to it
        const redirectTo = role !== 'guest' ? consumePreferredRoute(role) : null;
        if (redirectTo) {
          if (redirectTo.indexOf('http') === 0)
            window.location.href = redirectTo;
          else
            this.props.history.push(redirectTo);
          return;
        }
        //else go to previous route
        if (['/login', '/logout', '/social-login/' + token].indexOf(this.props.location.pathname) !== -1)
          this.props.history.push(getAdminRoles().indexOf(role) !== -1 ? '/admin' : '/');
        else
          this.props.history.push(this.props.location.pathname);
      }).catch((error) => {
        console.log(error);
        let newState = this.state;
        //Show SnackBar
        showError(error);
        newState.loading = false;
        this.setState(newState);
      });

  }
  /*
  -----------------------------------------------------------------------
  RENDER Functions
  -----------------------------------------------------------------------
  */

  /* Render Page */
  render() {
    const { classes } = this.props;
    return (
      <div>
        <main className={classes.main}>
          <CssBaseline />
          <Paper className={classes.paper}>
            <Avatar className={classes.avatar}>
              <img alt='edSeed Logo ' src={AppConfig.base + '/logo.png?v1'} style={{ width: '95%' }} />
            </Avatar>
            <p>Logging In</p>
            <Loader size='40' />

          </Paper>

        </main>

      </div>

    );
  }
}

SocialLogin.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(SocialLogin));
